import React from 'react';

import { ClOfferCardNotFound } from '@search/classified-common/src/offer/card/notFound/ClOfferCardNotFound';
import { useRelatedOffers } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery/useRelatedOffers';
import { useClImageLazySrcSetUrl, ImageLazySrcSetProvide } from '@search/vtbeco-frontend-core/domain/image/lazy/ImageLazySrcSet';

// import { OfferSnippet } from '../../Snippet/OfferSnippet';

export function OfferPageNotFoundDesk() {
    const {
        relativeTitle,
        goToRelativeOffers,
        searchOffers, count,
        // mortgageBannerTextVariant, mortgageBannerMinutesVariant
    } = useRelatedOffers();
    const getUrl = useClImageLazySrcSetUrl({ baseUrl: searchOffers?.[0]?.gallery?.baseUrl });

    return (
        <ImageLazySrcSetProvide getUrl={getUrl}>
            <ClOfferCardNotFound
                title={relativeTitle}
                goToRelativeOffers={goToRelativeOffers}
                count={count}
            >
            </ClOfferCardNotFound>
        </ImageLazySrcSetProvide>
    );
}
